"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { BrandLogo } from "~/components/ui/brand-logo";
import { Facebook, Twitter, Linkedin, Instagram } from "lucide-react";
import { useTranslations } from "next-intl";
export function Footer(t0) {
  const $ = _c(110);
  const {
    hasPosts: t1,
    enablePricing: t2
  } = t0;
  const hasPosts = t1 === undefined ? true : t1;
  const enablePricing = t2 === undefined ? false : t2;
  const t = useTranslations("layout.footer");
  const pathname = usePathname();
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Link href="/" className="mb-6 flex items-center gap-2"><BrandLogo iconSize="w-10 h-10" textSize="lg" /></Link>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== t) {
    t4 = t("description");
    $[1] = t;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t4) {
    t5 = <p className="mb-6 max-w-sm text-gray-600 dark:text-gray-400">{t4}</p>;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex gap-4"><Link href="#" className="text-gray-400 transition-colors hover:text-blue-600 dark:hover:text-blue-400"><Instagram className="h-5 w-5" /></Link></div>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t5) {
    t7 = <div className="col-span-2 lg:col-span-2">{t3}{t5}{t6}</div>;
    $[6] = t5;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t) {
    t8 = t("product.title");
    $[8] = t;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t8) {
    t9 = <h4 className="mb-4 font-semibold text-gray-900 dark:text-white">{t8}</h4>;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t) {
    t10 = t("product.features");
    $[12] = t;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== pathname || $[15] !== t10) {
    t11 = <li><FooterLink href="/features" currentPath={pathname}>{t10}</FooterLink></li>;
    $[14] = pathname;
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== enablePricing || $[18] !== pathname || $[19] !== t) {
    t12 = enablePricing && <li><FooterLink href="/pricing" currentPath={pathname}>{t("product.pricing")}</FooterLink></li>;
    $[17] = enablePricing;
    $[18] = pathname;
    $[19] = t;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t) {
    t13 = t("product.roadmap");
    $[21] = t;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== pathname || $[24] !== t13) {
    t14 = <li><FooterLink href="#" currentPath={pathname}>{t13}</FooterLink></li>;
    $[23] = pathname;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t11 || $[27] !== t12 || $[28] !== t14) {
    t15 = <ul className="space-y-3 text-sm text-gray-600 dark:text-gray-400">{t11}{t12}{t14}</ul>;
    $[26] = t11;
    $[27] = t12;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t15 || $[31] !== t9) {
    t16 = <div>{t9}{t15}</div>;
    $[30] = t15;
    $[31] = t9;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t) {
    t17 = t("resources.title");
    $[33] = t;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t17) {
    t18 = <h4 className="mb-4 font-semibold text-gray-900 dark:text-white">{t17}</h4>;
    $[35] = t17;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== hasPosts || $[38] !== pathname || $[39] !== t) {
    t19 = hasPosts && <li><FooterLink href="/blog" currentPath={pathname}>{t("resources.blog")}</FooterLink></li>;
    $[37] = hasPosts;
    $[38] = pathname;
    $[39] = t;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t) {
    t20 = t("resources.guides");
    $[41] = t;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== pathname || $[44] !== t20) {
    t21 = <li><FooterLink href="#" currentPath={pathname}>{t20}</FooterLink></li>;
    $[43] = pathname;
    $[44] = t20;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== t) {
    t22 = t("resources.helpCenter");
    $[46] = t;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] !== pathname || $[49] !== t22) {
    t23 = <li><FooterLink href="#" currentPath={pathname}>{t22}</FooterLink></li>;
    $[48] = pathname;
    $[49] = t22;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] !== t19 || $[52] !== t21 || $[53] !== t23) {
    t24 = <ul className="space-y-3 text-sm text-gray-600 dark:text-gray-400">{t19}{t21}{t23}</ul>;
    $[51] = t19;
    $[52] = t21;
    $[53] = t23;
    $[54] = t24;
  } else {
    t24 = $[54];
  }
  let t25;
  if ($[55] !== t18 || $[56] !== t24) {
    t25 = <div>{t18}{t24}</div>;
    $[55] = t18;
    $[56] = t24;
    $[57] = t25;
  } else {
    t25 = $[57];
  }
  let t26;
  if ($[58] !== t) {
    t26 = t("legal.title");
    $[58] = t;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  let t27;
  if ($[60] !== t26) {
    t27 = <h4 className="mb-4 font-semibold text-gray-900 dark:text-white">{t26}</h4>;
    $[60] = t26;
    $[61] = t27;
  } else {
    t27 = $[61];
  }
  let t28;
  if ($[62] !== t) {
    t28 = t("legal.legalNotice");
    $[62] = t;
    $[63] = t28;
  } else {
    t28 = $[63];
  }
  let t29;
  if ($[64] !== pathname || $[65] !== t28) {
    t29 = <li><FooterLink href="/mentions-legales" currentPath={pathname}>{t28}</FooterLink></li>;
    $[64] = pathname;
    $[65] = t28;
    $[66] = t29;
  } else {
    t29 = $[66];
  }
  let t30;
  if ($[67] !== t) {
    t30 = t("legal.terms");
    $[67] = t;
    $[68] = t30;
  } else {
    t30 = $[68];
  }
  let t31;
  if ($[69] !== pathname || $[70] !== t30) {
    t31 = <li><FooterLink href="/cgu" currentPath={pathname}>{t30}</FooterLink></li>;
    $[69] = pathname;
    $[70] = t30;
    $[71] = t31;
  } else {
    t31 = $[71];
  }
  let t32;
  if ($[72] !== t) {
    t32 = t("legal.privacy");
    $[72] = t;
    $[73] = t32;
  } else {
    t32 = $[73];
  }
  let t33;
  if ($[74] !== pathname || $[75] !== t32) {
    t33 = <li><FooterLink href="/confidentialite" currentPath={pathname}>{t32}</FooterLink></li>;
    $[74] = pathname;
    $[75] = t32;
    $[76] = t33;
  } else {
    t33 = $[76];
  }
  let t34;
  if ($[77] !== t) {
    t34 = t("legal.cookies");
    $[77] = t;
    $[78] = t34;
  } else {
    t34 = $[78];
  }
  let t35;
  if ($[79] !== pathname || $[80] !== t34) {
    t35 = <li><FooterLink href="#" currentPath={pathname}>{t34}</FooterLink></li>;
    $[79] = pathname;
    $[80] = t34;
    $[81] = t35;
  } else {
    t35 = $[81];
  }
  let t36;
  if ($[82] !== t29 || $[83] !== t31 || $[84] !== t33 || $[85] !== t35) {
    t36 = <ul className="space-y-3 text-sm text-gray-600 dark:text-gray-400">{t29}{t31}{t33}{t35}</ul>;
    $[82] = t29;
    $[83] = t31;
    $[84] = t33;
    $[85] = t35;
    $[86] = t36;
  } else {
    t36 = $[86];
  }
  let t37;
  if ($[87] !== t27 || $[88] !== t36) {
    t37 = <div>{t27}{t36}</div>;
    $[87] = t27;
    $[88] = t36;
    $[89] = t37;
  } else {
    t37 = $[89];
  }
  let t38;
  if ($[90] !== t16 || $[91] !== t25 || $[92] !== t37 || $[93] !== t7) {
    t38 = <div className="mb-12 grid grid-cols-2 gap-8 md:grid-cols-4 lg:grid-cols-5">{t7}{t16}{t25}{t37}</div>;
    $[90] = t16;
    $[91] = t25;
    $[92] = t37;
    $[93] = t7;
    $[94] = t38;
  } else {
    t38 = $[94];
  }
  let t39;
  if ($[95] !== t) {
    t39 = t("copyright", {
      year: new Date().getFullYear()
    });
    $[95] = t;
    $[96] = t39;
  } else {
    t39 = $[96];
  }
  let t40;
  if ($[97] !== t39) {
    t40 = <p className="text-sm text-gray-500 dark:text-gray-400">{t39}</p>;
    $[97] = t39;
    $[98] = t40;
  } else {
    t40 = $[98];
  }
  let t41;
  if ($[99] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = <div className="h-2 w-2 rounded-full bg-green-500" />;
    $[99] = t41;
  } else {
    t41 = $[99];
  }
  let t42;
  if ($[100] !== t) {
    t42 = t("systemStatus");
    $[100] = t;
    $[101] = t42;
  } else {
    t42 = $[101];
  }
  let t43;
  if ($[102] !== t42) {
    t43 = <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">{t41}<span>{t42}</span></div>;
    $[102] = t42;
    $[103] = t43;
  } else {
    t43 = $[103];
  }
  let t44;
  if ($[104] !== t40 || $[105] !== t43) {
    t44 = <div className="flex flex-col items-center justify-between gap-4 border-t border-gray-200 pt-8 md:flex-row dark:border-gray-800">{t40}{t43}</div>;
    $[104] = t40;
    $[105] = t43;
    $[106] = t44;
  } else {
    t44 = $[106];
  }
  let t45;
  if ($[107] !== t38 || $[108] !== t44) {
    t45 = <footer className="border-t border-gray-200 bg-gray-50 pt-16 pb-8 dark:border-gray-800 dark:bg-gray-900"><div className="container mx-auto px-4">{t38}{t44}</div></footer>;
    $[107] = t38;
    $[108] = t44;
    $[109] = t45;
  } else {
    t45 = $[109];
  }
  return t45;
}
function FooterLink(t0) {
  const $ = _c(4);
  const {
    href,
    currentPath,
    children
  } = t0;
  const isActive = href !== "#" && currentPath.includes(href);
  const t1 = `transition-colors ${isActive ? "font-bold text-blue-600 dark:text-blue-400" : "text-gray-600 hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-400"}`;
  let t2;
  if ($[0] !== children || $[1] !== href || $[2] !== t1) {
    t2 = <Link href={href} className={t1}>{children}</Link>;
    $[0] = children;
    $[1] = href;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}